module.exports = __webpack_public_path__ + "img/rajneesh.1685e773.png";